// export const isProdHost = true;


export const isProdHost = window.location.hostname === 'quiq.kz';

export const CAMUNDA_URL = isProdHost ? process.env.REACT_APP_CAMUNDA_PROD : process.env.REACT_APP_CAMUNDA_DEV;

export const BACKEND_URL = isProdHost ? process.env.REACT_APP_BACKEND_PROD : process.env.REACT_APP_BACKEND_DEV;


/**
 * Бэк ECASH Analytics (казначейство: перемещения, лимиты). Отдельный сервис, но принимает
 * тот же токен, что и бэк ECASH. Адреса задаются в .env: REACT_APP_ANALYTICS_DEV / REACT_APP_ANALYTICS_PROD.
 */
export const ANALYTICS_URL = isProdHost ? process.env.REACT_APP_ANALYTICS_PROD : process.env.REACT_APP_ANALYTICS_DEV;

/**
 * Инкассация v2: вкладка «Инкассация» в «Перемещениях» и переход на неё из старого подтверждения перемещения.
 * Переключается сборкой/окружением: `REACT_APP_INCASSATION_VERSION=2` в .env. Без значения работает v1 — как раньше.
 */
export const INCASSATION_V2 = process.env.REACT_APP_INCASSATION_VERSION === '2';
